<template>
  <div class="animated fadeIn">
    <h4 class="page-title">User Services</h4>
    <hr />
    <div class="row">
      <div class="col">
        <div style="margin: 0 auto; width: 10px;" v-if="isFetching">
          <div class="loader-dark-blue medium mb-5 mt-5"></div>
        </div>
        <div class="mb-3" v-show="!isFetching">
          <span v-show="userServices.length">Number of data found: <b-badge pill variant="primary">{{userServices.length}}</b-badge></span>
          <b-btn class="float-right" variant="primary" size="sm" @click="add()" v-show="!isFetching"><i class="fa fa-plus"></i> Add</b-btn>
        </div>
        <b-alert variant="danger"
          class="text-center"
          :show="!isFetching && !userServices.length">
          Data is empty
        </b-alert>
        <b-table responsive hover striped :fields="fields" :items="userServices" :per-page="itemsPerPage" :current-page="currentPage" v-if="userServices.length">
          <template v-slot:cell(STATUS)="row">
            <span class="badge badge-sm" v-bind:class="{'badge-success': row.value, 'badge-danger': !row.value}">{{row.value ? 'ACTIVE' : 'INACTIVE'}}</span>
          </template>
          <template v-slot:cell(ACTIONS)="row">
            <b-btn variant="warning" size="sm" @click="edit(row.item)" v-b-tooltip.hover title="Edit service">
              <i class="fa fa-pencil-square-o"></i>
            </b-btn>
          </template>
        </b-table>
        <b-pagination v-show="userServices.length > 10" :total-rows="userServices.length" :per-page="itemsPerPage" v-model="currentPage" />
      </div>
    </div>
  </div>
</template>
<script>
import { server, fieldsService } from '@/services/'
import { UserServicesModal } from '@/components/modals/'
import { mapState } from 'vuex'

export default {
  name: 'user-services',
  data () {
    return {
      errorMsg: Object,
      itemsPerPage: 10,
      currentPage: 1,
      itemsCount: 0,
      fields: fieldsService.USER_SERVICES
    }
  },
  methods: {
    add () {
      this.$modal.show(UserServicesModal, {mode: 'Add'}, {height: 'auto', scrollable: true});
    },
    edit (obj) {
      this.$modal.show(UserServicesModal, {mode: 'Edit', model: obj}, {height: 'auto', scrollable: true});
    }
  },
  computed: {
    ...mapState('userService', {
      isFetching: state => state.isFetching,
      userServices: state => state.items
    })
  },
  created () {
    this.$store.commit('userService/setIsFetching', true)
    this.$store.cache.dispatch('userService/getAll').then(
      resp => this.$store.commit('userService/setIsFetching', false)
    )
  }
}
</script>
